<template>
    <transition name="fade">
        <div class="row justify-content-center">
            <div class="col-lg-10 col-md-12 col-sm-12">

                <div class="card">
                    <div class="card-header">
                        <h3 class="card-title bold">Share with us some information about your Asset Size and Annual Sales</h3>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-12">
                                <!-- <p class="bold fs-18">Reference for Enterprise Categories by Asset size.</p> -->
                                <div class="table-responsive text-center table-middle">
                                    <table class="table table-sm table-bordered mb-0">
                                        <thead>
                                            <tr>
                                                <th>Enterprise Category</th>
                                                <th>Asset Size</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Micro-Enteprise</td>
                                                <td>below 3,000,000</td>
                                            </tr>
                                            <tr>
                                                <td>Small Enterprise</td>
                                                <td>3,000,001 to 15,000,000</td>
                                            </tr>
                                            <tr>
                                                <td>Medium Enterprise</td>
                                                <td>15,000,001 to 100,000,000</td>
                                            </tr>

                                        </tbody>
                                    </table>
                                </div>
                                <hr>

                                <div class="row">

                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Estimated Asset Size (excluding land)</label>
                                            <div class="input-group input-group-sm">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text" style="background-color: transparent !important;">&#8369</span>
                                                </div>
                                                <input v-if="asset_size" @blur="asset_size=false" @paste.prevent @keypress="maxNum($event)" type="number" class="form-control" v-model="formLoan.asset_size" :class="{'is-invalid': $parent.submitting && $v.formLoan.asset_size.$error}">
                                                <input v-else @focus="asset_size=true" type="text" class="form-control" :value="formLoan.asset_size ? $options.filters.curr(formLoan.asset_size) : null" :class="{'is-invalid': $parent.submitting && $v.formLoan.asset_size.$error}">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Estimated Annual Sales</label>
                                            <div class="input-group input-group-sm">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text" style="background-color: transparent !important;">&#8369</span>
                                                </div>
                                                <input v-if="annual_sale" @blur="annual_sale=false" @paste.prevent @keypress="maxNum($event)" type="tel" class="form-control" v-model="formLoan.annual_sale" :class="{'is-invalid': $parent.submitting && $v.formLoan.annual_sale.$error}">
                                                <input v-else @focus="annual_sale=true" type="text" class="form-control" :value="formLoan.annual_sale ? $options.filters.curr(formLoan.annual_sale) : null" :class="{'is-invalid': $parent.submitting && $v.formLoan.annual_sale.$error}">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                    <div class="card-footer">
                        <button class="btn btn-primary" @click="$emit('back')"><i class="fas fa-arrow-left mr-1"></i>Back</button>
                        <button class="btn btn-primary float-right" @click="next">Next<i class="fas fa-arrow-right ml-1"></i></button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
    import moment from 'moment';
    import {
        required,
        minLength,
        requiredIf
    } from 'vuelidate/lib/validators';

    export default {
        props: ['formLoan'],
        data() {
            return {
                asset_size: false,
                annual_sale: false,
            }
        },

        validations: {
            formLoan: {
                asset_size: {
                    required
                },
                annual_sale: {
                    required
                },
                // tin: {
                //     required,
                //     minLength: minLength(15),
                // },
            },
        },
        created() {
            this.evalMaxLoan();
        },
        methods: {
            evalMaxLoan() {
                let max13 = this.formLoan.emp13;
                if (max13 >= 40) {
                    max13 = 40;
                    this.formLoan.max_loan = max13 * 12000;
                } else {
                    this.formLoan.max_loan = max13 * 12000;
                }
            },
            next() {
                this.$parent.submitting = false;
                this.$parent.submitting = true;
                this.$v.formLoan.$touch();
                if (this.$v.formLoan.$invalid) {} else {
                    this.$emit('next');
                }
            },

            maxNum(e) {
                let val = e.target.value;
                let dot = val.indexOf('.') !== -1
                let dec = val.substr(val.indexOf('.'));
                if (val <= 99999999) {
                    if (dot) {
                        if (dec.length >= 3) {
                            e.preventDefault();
                        } else {
                            return true;
                        }
                    } else {
                        return true;
                    }
                } else e.preventDefault();
            },
        },
        computed: {

        },
        mounted() {}
    }
</script>



<style scoped>
    label {
        font-weight: 400 !important;
    }

    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    /* Firefox */
    input[type=number] {
        -moz-appearance: textfield;
    }
</style>